import { render, staticRenderFns } from "./into-abroadlogistics-check.vue?vue&type=template&id=de2efa0c"
import script from "./into-abroadlogistics-check.vue?vue&type=script&lang=ts"
export * from "./into-abroadlogistics-check.vue?vue&type=script&lang=ts"
import style0 from "./into-abroadlogistics-check.vue?vue&type=style&index=0&id=de2efa0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports